jQuery(document).ready(function ($) {
    var t = 0;
    !(function () {
        document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)
            ? (t = document.documentElement.clientWidth)
            : document.body && (document.body.clientWidth || document.body.clientHeight) && (t = document.body.clientWidth);
    })(),
        $(".menu-toggle").click(function () {
            $(".menu").toggleClass("active");
        }),
        t > 767 && $(".header-nav").scrollToFixed();
    new Swiper(".slider", { autoplay: 2500, speed: 1e3, effect: "fade", loop: !0 }),
        new Swiper(".tem-slider", { slidesPerView: 1, autoplay: 2500, autoplayDisableOnInteraction: !0, loop: !0, pagination: ".swiper-pagination", paginationClickable: !0 }),
        new Swiper(".carousel", {
            pagination: !1,
            nextButton: ".swiper-button-next",
            prevButton: ".swiper-button-prev",
            slidesPerView: 3,
            paginationClickable: !0,
            spaceBetween: 10,
            loop: !0,
            breakpoints: { 768: { slidesPerView: 1, pagination: ".swiper-pagination-carousel" } },
        });




/* ==========================================================================
    == RECHERCHE ==
    ========================================================================== */
    $(".search-arrow").click(function(){
    	$(this).parent().find("select").click();
    });

    /*
    if ($(".search-form").length ) {
        $("#dt-deb").datepicker({
            'format': 'yyyy-m-d',
            'autoclose': true
        });
    }
    */

    /*
    if ($.fn.pickadate && $(".search-form").length ) {
        $('#dt-deb').pickadate({
            format: 'dd/mm/yyyy',
            formatSubmit: 'dd/mm/yyyy',
            hiddenName: true,
            firstDay: 1,
            min: true,
            max: 0,
            container: '.search-form'
        });

        $('#dt-fin').pickadate({
            format: 'dd/mm/yyyy',
            formatSubmit: 'dd/mm/yyyy',
            hiddenName: true,
            firstDay: 1,
            min: true,
            max: 0,
            container: '.search-form'
        });

        var from_$input = $('#dt-deb').pickadate(),
                from_picker = from_$input.pickadate('picker')

        var to_$input = $('#dt-fin').pickadate(),
            to_picker = to_$input.pickadate('picker')


        // Check if there’s a “from” or “to” date to start with.
        if ( from_picker.get('value') ) {
            to_picker.set('min', from_picker.get('select'))
        }
        if ( to_picker.get('value') ) {
            from_picker.set('max', to_picker.get('select'))
        }

        // When something is selected, update the “from” and “to” limits.
        from_picker.on('set', function(event) {
            if ( event.select ) {
            to_picker.set('min', from_picker.get('select'))
            }
            else if ( 'clear' in event ) {
            to_picker.set('min', false)
            }
        })
        to_picker.on('set', function(event) {
            if ( event.select ) {
            from_picker.set('max', to_picker.get('select'))
            }
            else if ( 'clear' in event ) {
            from_picker.set('max', false)
            }
        })
    }
    */



    if (
        ($(".prog-item-btn").click(function () {
            var t = $(this),
                a = t.data("ref");
            a && (a = "<br><br>Référence : " + a),
                $("#retraite").val(t.data("titre") + " - du " + t.data("deb") + " au " + t.data("fin")),
                $("#lightbox-form-inscription-titre").html(t.data("titre")),
                $("#lightbox-form-inscription-dates").html("du " + t.data("deb") + "<br> au " + t.data("fin") + a),
                $("#retraitereference").val(t.data("ref"));
        }),
        $(".acc-ttl").click(function () {
            $(this).parent(".acc-item").find(".acc-content").toggle("fast");
        }),
        $(".acc").length && window.location.hash)
    ) {
        var o = window.location.hash.substring(1);
        $("#" + o).addClass("open");
    }
    $(".tem-card, .tem-all").on("click", function (t) {
        var a = $(this).data("featherlightPerso");
        $.featherlight(a);
        var i = $(this).data("yt");
        i && $(".featherlight " + a).html('<iframe src="https://www.youtube.com/embed/' + i + '?autoplay=1" frameborder="0" allowfullscreen></iframe>');
    });
});
